import { useCallback } from 'react';
import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api, Response } from '@/api';
import { API_URL } from '@/dtos';

import { RawNotification } from '../notification.types';

import { QUERY_KEY as DISMISSED_QUERY_KEY } from './useDismissedNotifications.query';

export const QUERY_KEY = 'getNotifications';

export default () => {
  const queryClient = useQueryClient();
  const mutation = useMutation((id?: string) =>
    api.patch(
      id ? API_URL.APP_NOTIFICATIONS_DISMISSED_BY_CORRESPONDENCE_ID(id) : API_URL.APP_NOTIFICATIONS_DISMISSED,
      undefined
    )
  );
  const handleDismissAll = useCallback(async () => {
    await mutation.mutateAsync('');
    const queryData = queryClient.getQueryData<Response<RawNotification[]>>([QUERY_KEY]);
    if (queryData) {
      queryClient.setQueryData([QUERY_KEY], {
        ...queryData,
        data: [],
      });
      queryClient.invalidateQueries({
        queryKey: [DISMISSED_QUERY_KEY],
      });
    }
  }, [mutation, queryClient]);
  const handleDismissById = useCallback(
    async (id?: string) => {
      if (!id) {
        return;
      }

      await mutation.mutateAsync(id);

      const queryData = queryClient.getQueryData<Response<RawNotification[]>>([QUERY_KEY]);
      if (queryData) {
        queryClient.setQueryData([QUERY_KEY], {
          ...queryData,
          data: queryData.data.filter((item) => `${item.id}` !== id),
        });
        queryClient.invalidateQueries({
          queryKey: [DISMISSED_QUERY_KEY],
        });
      }
    },
    [mutation, queryClient]
  );
  return {
    handleDismissAll,
    handleDismissById,
  };
};
